import Header from "Components/Common/Header/Header";
import MyInviteBody from "Components/MyInvites/MyInviteBody/MyInviteBody";
import React from "react";

const MyInvites = () => {
  return (
    <>
      <Header />
      <MyInviteBody />
    </>
  );
};

export default MyInvites;
